import React, { useEffect, useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useGetUnits } from "../../hooks/data/data_unit";
import { useGetMaterialCategories, useGetMaterials, useGetMaterialSubcategories } from "../../hooks/data/data_material";
import { OfferMaterialPositionAssign } from "../offer/Childs/OfferMaterialPositionAssign";
import { IInvoiceMaterialPosition } from "../../interfaces/IInvoiceMaterialPosition";
import { getTmpId } from "../core/generic_helpders";
import { InvoicePosMaterialRow } from "./InvoicePosMaterialRow";
import { getEmptyOfferMaterialPosition, OfferMaterialPositionEdit } from "../offer/Childs/OfferMaterialPositionEdit";
import { IOfferMaterialPosition } from "../../interfaces/IOfferMaterialPosition";


interface IProps {
    invoice:IInvoice;
    setInvoice: Function;
    isOpenNew: boolean;
    isOpenAssignMaterial: boolean;
    setIsOpenNew: Function;
    setIsOpenAssignMaterial: Function;
}

export const InvoicePosMaterialTable:React.FC<IProps> = ({
    invoice,
    setInvoice,
    isOpenNew,
    isOpenAssignMaterial,
    setIsOpenNew,
    setIsOpenAssignMaterial
}) => {
    const { units } = useGetUnits();
    const { materialArray } = useGetMaterials();
    const { materialCategoryArray } = useGetMaterialCategories();
    const { materialSubcategoryArray } = useGetMaterialSubcategories();

    const [assignMaterialList,setAssignMaterialList] = useState([]);

    const [materialPositons,setMaterialPositons] = useState(invoice.InvoiceMaterialPositions);

    useEffect(() => {
        setInvoice({
            ...invoice,
            InvoiceMaterialPositions: materialPositons
        })
    },[materialPositons])


    const total = materialPositons
        .map(pos => pos.price_per_unit*pos.units)
        .reduce((a,b) => a+b,0);

    const [newMaterialPos, setNewMaterialPos] = useState(
        getEmptyOfferMaterialPosition(invoice.id, materialPositons.map(invMate => {
                return {
                    ...invMate,
                    Offer: invoice.id,
                    position: 1,
                    Partner: null
                } as IOfferMaterialPosition
        }))
    );


    const handleAddAssignMaterial = () => {
        let addMaterial:IInvoiceMaterialPosition[] = [];
        const minId = getTmpId(materialPositons);

        assignMaterialList.map((assignMat,idx) => {
            const testMaterial = materialArray.find(mat => mat.id === assignMat);

            if (testMaterial) {
                addMaterial.push({
                    description: testMaterial.description,
                    id: minId-idx,
                    Invoice: invoice.id,
                    Material: testMaterial.id,
                    MaterialCategory: testMaterial.MaterialCategory,
                    MaterialSubcategory: testMaterial.MaterialSubcategory,
                    price_per_unit: testMaterial.retail_price,
                    title: testMaterial.title,
                    Unit: testMaterial.Unit,
                    units: 1
                })
            }
        })

        setMaterialPositons([
            ...materialPositons,
            ...addMaterial
        ]);
        setIsOpenAssignMaterial(false); 
        setAssignMaterialList([]);

    }

    const handleAddPosition = () => {
        const tmpId = getTmpId(materialPositons)
        setMaterialPositons([
            ...materialPositons,
            {
                ...newMaterialPos,
                Invoice: invoice.id,
                id: tmpId
            }
        ])
        setIsOpenNew(false);
        setNewMaterialPos(
            getEmptyOfferMaterialPosition(invoice.id, materialPositons.map(invMate => {
                    return {
                        ...invMate,
                        Offer: invoice.id,
                        position: 1,
                        Partner: null
                    } as IOfferMaterialPosition
            }))
        )
    }


    return(
        <>
            {(isOpenAssignMaterial) &&
                <Dialog 
                    open 
                    onClose={() => setIsOpenAssignMaterial(false)} 
                    maxWidth="md" 
                    fullWidth
                >
                    <DialogTitle>Material zuweisen</DialogTitle>
                    <DialogContent>
                        <OfferMaterialPositionAssign
                            key={`offermaterialposition-new`}
                            sx={{ mt: 2 }}
                            materialArray={materialArray}
                            materialCategoryArray={materialCategoryArray}
                            materialSubcategoryArray={materialSubcategoryArray}
                            assignMaterialList={assignMaterialList}
                            setAssignMaterialList={setAssignMaterialList}
                            materialDocumentArray={undefined}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenAssignMaterial(false)}>
                            Abbruch
                        </Button>
                        <Button
                            variant="contained"
                            disabled={assignMaterialList.length === 0}
                            onClick={handleAddAssignMaterial}
                        >
                            Hinzufügen
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {(isOpenNew) && 
                <Dialog 
                    open 
                    onClose={() => setIsOpenNew(false)} 
                    maxWidth="md" 
                    fullWidth
                >
                    <DialogTitle>Neue Materialposition</DialogTitle>
                    <DialogContent>
                        <OfferMaterialPositionEdit
                            key={`offermaterialposition-new`}
                            sx={{ mt: 2 }}
                            offerId={invoice.id}
                            currentMaterialPosition={newMaterialPos}
                            setCurrentMaterialPosition={setNewMaterialPos}
                            unitArray={units || []}
                            materialArray={materialArray}
                            materialCategoryArray={materialCategoryArray}
                            materialSubcategoryArray={materialSubcategoryArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenNew(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleAddPosition}>
                            Hinzufügen
                        </Button>
                    </DialogActions>
                </Dialog>
            }




            <Typography
                variant="h5"
            >
                Materialpositionen
            </Typography>

            <Table sx={{ mb: 5 }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ p: 0, width: 50 }}></TableCell>
                        <TableCell sx={{ p: 0, width: 80 }}>Artk.Nr.</TableCell>
                        {/* <TableCell sx={{p:0, width: 150}}>Partner</TableCell> */}
                        <TableCell sx={{ minWidth: 300 }}>Position</TableCell>
                        <TableCell sx={{ p: 0, width: 50 }}></TableCell>
                        {/*
                            <TableCell sx={{p:0, width: 150}}>P.p.S.</TableCell>
                         */}

                        <TableCell sx={{ p: 0, width: 150 }}>Einheiten</TableCell>
                        <TableCell sx={{ p: 0, width: 50 }}>Einheit</TableCell>
                        <TableCell sx={{ p: 0, width: 150 }}>Preis</TableCell>
                        <TableCell sx={{ p: 0, width: 50 }}>Total</TableCell>
                        <TableCell sx={{ p: 0, width: 50 }}></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {materialPositons.map(invMat =>
                        <InvoicePosMaterialRow
                            key={`row-imv-materia-${invMat.id}`}
                            invMaterial={invMat}
                            invMaterials={materialPositons}
                            units={units || []}
                            materialCategories={materialCategoryArray}
                            materialSubcategories={materialSubcategoryArray}
                            materials={materialArray}
                            setInvMaterials={setMaterialPositons}
                        />
                    )}

                    <TableRow>
                        <TableCell colSpan={5} />
                        <TableCell colSpan={2}>
                            <b>Summe</b>
                        </TableCell>
                        <TableCell>{total.toLocaleString("de-DE", { style: "currency", currency: "EUR" })}</TableCell>
                        <TableCell />
                    </TableRow>

                    <TableRow>
                        <TableCell colSpan={5} />
                        <TableCell sx={{ borderBottom: "solid 1px" }} colSpan={2}>
                            <b>MwSt.</b>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "solid 1px" }}>
                            {(total * invoice.vat).toLocaleString("de-DE", { style: "currency", currency: "EUR" })}
                        </TableCell>
                        <TableCell />
                    </TableRow>

                    <TableRow>
                        <TableCell colSpan={5} />
                        <TableCell sx={{ borderBottom: "solid 1px" }} colSpan={2}>
                            <b>Total</b>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "solid 1px" }}>
                            {(total * invoice.vat + total).toLocaleString("de-DE", {
                                style: "currency",
                                currency: "EUR",
                            })}
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}